export default "__VITE_ASSET__PjvB2LRv__"